import { sobre } from "@/content";
import { Reveal, Overline } from "./Reveal";

const IMG = "https://images.pexels.com/photos/8640331/pexels-photo-8640331.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const About = () => (
  <section id="sobre" data-testid="about-section" className="relative scroll-mt-20 py-20 md:py-28 lg:py-36">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 md:gap-16 lg:grid-cols-2 lg:gap-24 lg:px-8">
      <Reveal className="relative order-2 lg:order-1">
        <div className="relative aspect-[4/3] overflow-hidden sm:aspect-[4/5] rounded-3xl border border-white/10">
          <img src={IMG} alt="Fibras de luz azul representando fluxo de dados" data-testid="about-image"
            className="h-full w-full object-cover opacity-70" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#030712] via-[#030712]/30 to-transparent" />
          <div className="glass absolute inset-x-6 bottom-6 rounded-2xl p-6">
            <img src="/logo-icon-mark.png" alt="iCON Finanças Inteligentes" data-testid="about-logo"
              className="h-14 w-auto drop-shadow-[0_0_16px_rgba(103,232,249,0.3)] sm:h-16" />
            <p className="text-brand-gradient mt-3 inline-block text-sm uppercase tracking-[0.25em]">Finanças Inteligentes</p>
          </div>
        </div>
      </Reveal>
      <div className="order-1 lg:order-2">
        <Reveal>
          <Overline>{sobre.overline}</Overline>
          <h2 className="font-display mt-5 text-3xl font-semibold leading-tight tracking-tight text-white md:text-5xl">{sobre.titulo}</h2>
        </Reveal>
        {sobre.paragrafos.map((p, i) => (
          <Reveal key={i} delay={0.1 + i * 0.05}>
            <p className="mt-6 text-base leading-relaxed text-slate-300 md:text-lg">{p}</p>
          </Reveal>
        ))}
        <div className="mt-12 space-y-4">
          {sobre.pilares.map((pl, i) => (
            <Reveal key={pl.titulo} delay={0.2 + i * 0.08}>
              <div data-testid={`about-pillar-${i}`}
                className="flex items-start gap-5 border-t border-white/10 pt-5">
                <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-cyan-300 shadow-[0_0_10px_#22d3ee]" />
                <div>
                  <p className="font-display text-lg font-semibold text-white">{pl.titulo}</p>
                  <p className="mt-1 text-[15px] leading-7 text-slate-300 sm:text-base">{pl.texto}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
